// The booking widget runs the app inside an iframe on "#/embedded/..." routes (old widget) or
// "#/widget/..." routes (new widget) — both for third-party embeds and for the hosted
// "/#/book/..." page (which only renders that iframe). Requests made from that context must never
// inherit a logged-in session from shared localStorage — only the booking's own guest_token is allowed.
const EMBEDDED_HASH_PREFIXES = ["#/embedded/", "#/widget/"]

export const isEmbeddedContext = () => EMBEDDED_HASH_PREFIXES.some((prefix) => window.location.hash.startsWith(prefix))

// Whether the widget runs inside our own hosted "/#/book/..." page (same origin, so its address bar
// can be changed). A third-party site's page can't be read, which counts as not hosted.
export const isOnHostedBookingPage = () => {
  try {
    return window.top !== window && window.top.location.origin === window.location.origin && window.top.location.hash.startsWith("#/book/")
  } catch {
    return false
  }
}

// On our hosted booking page, shows `path` (a #/book/... route) in its address bar without reloading
// it, so a refresh or the link opens what the widget shows. Nothing elsewhere.
export const showOnHostedBookingPage = (path) => {
  if (isOnHostedBookingPage()) window.top.history.replaceState(window.top.history.state, "", `#${path}`)
}

// The API's own message from a rejected api() call, whose `data.message` is a string,
// { base: [msg] } or { field: [msg] }. Null when there is none, so callers can fall back to their own.
export const getApiErrorMessage = (error) => {
  const message = error?.data?.message
  if (typeof message === "string") return message
  if (message && typeof message === "object") return Object.values(message).flat().find((value) => typeof value === "string") || null
  return null
}
